module.exports = __webpack_public_path__ + "static/media/leaf-icon.2dee5d57.svg";